// Requirements: at least 8 chars, lowercase, uppercase, digit and symbol. An empty value passes:
// `required` reports that one. (It used to end in `|| helpers.req('…')`, which is true for any
// non-empty string, so the rule never failed and weak passwords only bounced at Supabase.)
const STRONG = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export function strongPassword(value: string) {
    return !value || STRONG.test(value);
}
